import List from '../views/contacts/list'

export default [
    {
        path: '/admin/contacts',
        name: 'contacts',
        component: List,
    }
]
